namespace $.$$ {

	const transparent_cross = {
		content: '""',
		position: 'absolute',
		left: '-15%',
		top: '50%',
		width: '130%',
		height: '1px',
		backgroundColor: '#ff3333',
		transformOrigin: 'center',
		pointerEvents: 'none',
	} as const
	
	$mol_style_define( $shm_hitalama_color_switch, {
		
		width: '11rem',
		background: {
			color: 'transparent',
		},
		Option: {
			border: {
				style: 'solid',
				width: '1px',
				color: $mol_theme.line
			},
			position: 'relative',
			overflow: 'hidden',
			'[shm_hitalama_color_transparent]': {
				true: {
					'::before': {
						...transparent_cross,
						transform: 'rotate(45deg)',
					},
					'::after': {
						...transparent_cross,
						transform: 'rotate(-45deg)',
					},
				},
			},
			'[shm_hitalama_color_auto]': {
				true: {
					'::after': {
						content: '"auto"',
						position: 'absolute',
						left: '50%',
						top: '50%',
						transform: 'translate(-50%, -50%)',
						font: {
							size: '.8rem',
							// weight: 600,
						},
						lineHeight: '1',
						color: 'white',
						mixBlendMode: 'difference',
						pointerEvents: 'none',
					},
				},
			},
		},
		
	} )
	
}
